import { HttpErrorResponse } from '@angular/common/http'
import { Component, inject } from '@angular/core'
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms'
import { RouterLink } from '@angular/router'

import { TranslatePipe } from '@ngx-translate/core'
import { PaginatorModule } from 'primeng/paginator'

import { ButtonComponent } from 'app/_shared/components/button/button.component'
import { InputComponent } from 'app/_shared/components/input/input.component'
import { ServerErrorsListComponent } from 'app/_shared/components/server-errors-list/server-errors-list.component'
import { AuthService } from 'app/_shared/services/auth.service'
import { ToastService } from 'app/_shared/services/toast.service'
import { AppConfigService } from 'app/app-config.service'

@Component({
  selector: 'app-reset-password',
  imports: [
    ButtonComponent,
    InputComponent,
    PaginatorModule,
    ReactiveFormsModule,
    TranslatePipe,
    ServerErrorsListComponent,
    RouterLink
  ],
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss'
})
export class ResetPasswordComponent {
  serverErrors: HttpErrorResponse
  authService: AuthService = inject(AuthService)
  private appConfigService: AppConfigService = inject(AppConfigService)
  resetPasswordForm = new FormGroup({
    email: new FormControl('', {
      validators: [Validators.required, Validators.email],
      nonNullable: true
    })
  })
  toastService = inject(ToastService)
  get storefrontId(): number | null {
    return this.appConfigService.getAppConfig.id
  }

  onSubmit() {
    if (this.resetPasswordForm.valid) {
      const email = this.resetPasswordForm.get('email')?.value
      const storefrontId = this.storefrontId

      const payload = {
        email: email as string,
        storefront_id: storefrontId
      }
      this.authService.forgotPassword(payload).subscribe({
        next: () => {
          this.toastService.success('We sent you email with the password reset link!')
        },
        error: err => {
          this.serverErrors = err.error.errors
        }
      })
    }
  }
}
